/*
 * Common reducer used by `blocks` in `useReducer`.
 * `initialContentState` differs based on content form
 */
import {ContentActions, ContentActionsTypes} from './actions';

export const initialContentState: ContentState = {
  init: false,
  isPreview: false,
  form: {},
  tmpForm: null, /* used for preview */
};

export interface ContentState {
  init: boolean;
  isPreview: boolean;
  form: any;
  tmpForm: any | null, /* used for preview */
}

export function contentReducer(
  state: ContentState = initialContentState,
  action: ContentActions
): ContentState {

  switch (action.type) {
    case ContentActionsTypes.SET_INIT:
      return {
        ...state,
        init: action.payload,
      }
    case ContentActionsTypes.SET_CONTENT_FORM:
      return {
        ...state,
        form: action.payload,
        init: true,
      }
    case ContentActionsTypes.SET_PREVIEW:
      return {
        ...state,
        isPreview: true,
        form: {
          ...state.form,
          ...action.payload,
        },
        tmpForm: state.form,
      }
    case ContentActionsTypes.UNSET_PREVIEW:
      return {
        ...state,
        form: state.tmpForm,
        tmpForm: null,
        isPreview: false,
      }
    case ContentActionsTypes.SET_CONTENT_FORM_KEY_VALUE:
      return {
        ...state,
        form: {
          ...state.form || {},
          [action.payload.key]: action.payload.value,
        },
      }
    case ContentActionsTypes.SET_CONTENT_FORM_KEYS_VALUES:
      return {
        ...state,
        form: {
          ...state.form || {},
          ...action.payload,
        }
      }
    default:
      return state;
  }
}

// Functions
